import { render, staticRenderFns } from "./questionManage.vue?vue&type=template&id=f2ada9b2&scoped=true&"
import script from "./questionManage.vue?vue&type=script&lang=js&"
export * from "./questionManage.vue?vue&type=script&lang=js&"
import style0 from "./questionManage.vue?vue&type=style&index=0&id=f2ada9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ada9b2",
  null
  
)

export default component.exports